import React, { useEffect, useState } from "react";
import Header from "./Header";
import About from "./About";
import Portfolio from "./Portfolio";
import Contact from "./Contact";
import Footer from "./Footer";
import Releases from "./Releases";
import Brands from "./Pages/Brands";
import AdReels from "./Pages/AdReels";


function Home() {
  const [mainData, setMainData] = useState({});

  useEffect(() => {
    fetch("/mainData.json")
      .then((res) => res.json())
      .then((data) => {
        setMainData(data);
      });
  }, []);

  return (
    <>
      <Header data={mainData.main} />
      <Releases data={mainData.portfolio}/>
      <AdReels data={mainData.portfolio}/>
      <Portfolio data={mainData.portfolio} />
      <Brands data={mainData.portfolio}/>
      <About data={mainData.main} />
      <Contact data={mainData.main} />
      <Footer data={mainData.main} />
    </>
  );
}

export default Home;
